import React, {Component} from 'react';
import NavBar from '../navbar/NavBarTest';
import './UseZimble.scss'

class UseZimble extends Component {

    render() {


        return (

            <React.Fragment>
                <NavBar/>
                <section id="main" style={{paddingTop: 60}}>
                    <div class="container">
                        <article id="main-col">
                            <h2>
                                <p style={{color: "#044d76}"}}>How to Use Zimble:</p>
                            </h2>
                            <p>
                                <b><i>“What is the essence to life? To serve others and do good.” Aristotle</i></b>
                            </p>
                            <h3>
                                <p style={{color: "#044d76"}}>What is Zimble:</p>
                            </h3>
                            <p>
                                Zimble is a platform for users to serve one another by
                                giving them access to answer questions posted, receive
                                or give answers, upload, and watch educational videos for free. </p>
                            <p>We serve through this platform because it is our core
                                belief and vision that every student who is passionate about
                                learning can become a better version of themselves.
                            </p>
                            <h3>
                                <p style={{color: "#044d76"}}><b>Who should help?</b></p>
                            </h3>
                            <p>
                                On Zimble, everyone is an educator. This is our mission
                                to help students around the world reach their potential
                                regardless of their socioeconomic status.
                            </p>


                            <h3>

                                <p style={{color: "red"}}>The landing page will give you information about Zimble:</p>
                            </h3>


                            <dl>
                                <h3>
                                    <dt>What we Do:</dt>
                                </h3>
                                <dd>
                                    <li>Zimble's Mission Statement</li>
                                </dd>

                            </dl>

                            <dl>
                                <h3>
                                    <dt>About Us:</dt>
                                </h3>
                                <dd>
                                    <li>Vision Statement.</li>
                                    <li>Some Sobering Facts about Education WorldWide.</li>
                                </dd>

                            </dl>
                            <dl>
                                <h3>
                                    <dt>Meet the Team:</dt>
                                </h3>
                                <dd>
                                    <li>Features individuals that helped bring the Zimble platform to life.</li>
                                </dd>

                            </dl>

                            <dl>
                                <h3>
                                    <dt>How you can help:</dt>
                                </h3>
                                <dd>
                                    <li>Tell you how you can contribute and help Zimble students around the world.</li>
                                </dd>

                            </dl>


                            <dl>
                                <h3>
                                    <dt>Accessing the Zimble Platform</dt>
                                </h3>
                                <dd>
                                    <li>To able to have access to the Zimble platform, you can click on
                                        <a href="https://thezimble.com/platform"><strong> Go to Platform </strong></a>
                                        located at the top right of your
                                        browser.</li>
                                </dd>

                            </dl>


                            {/*<p>*/}
                            {/*    To able to have access to the Zimble platform, you can click on*/}
                            {/*    <a href="https://thezimble.com/platform"><strong> Go to Platform </strong></a>*/}
                            {/*    located at the top right of your*/}
                            {/*    browser.*/}
                            {/*</p>*/}

                            <h3>

                                <p style={{color: "red"}}>What you can do with Zimble before creating a new account:</p>
                            </h3>
                            <dd>
                                <li>Comment on questions.</li>
                                <li>View User's Answers.</li>
                                <li>View User's Questions.</li>
                                <li>Watch Videos.</li>
                                <li>Comments on Videos.</li>
                            </dd>

                            <h3>

                                <p style={{color: "red"}}>Additional Functionalities when you create a Zimble
                                    account:</p>
                            </h3>
                            <dd>
                                <li>Ask Questions.</li>
                                <li>Upload Videos.</li>
                                <li>Download Videos.</li>
                                <li>Edit or Delete Contents (Written Questions or Videos Uploads).</li>

                            </dd>

                            <h3>
                                <p style={{color: "red"}}>How to create an Account:</p>
                            </h3>
                            <dd>
                                <li>
                                    Click on “Sign In” located at the top right of your browser after clicking "<b>Go to
                                    Platform</b>".
                                </li>
                                <li>
                                    Click “Create an Account” at the bottom of the Sign-In Page.
                                </li>
                            </dd>
                            <p>
                                <strong>
                                    To create an account, you need the following:
                                </strong>
                            </p>
                            <dd>
                                <li>Full Name.</li>
                                <li>Correct Email Address.</li>
                                <li> New Password.</li>
                                <li>Read the Privacy Policy, and the Terms and Conditions.</li>
                                <li>Click Sign Up.</li>
                            </dd>
                            <p>
                                <strong>
                                    After you have created your account:
                                </strong>
                            </p>
                            <dd>
                                <li>A confirmation email will be sent to the email address that you created the account
                                    with. (Make sure you have the
                                    correct email address).
                                </li>
                                <li>Go to your email address and click on the confirmation link.</li>
                                <li>If you did not receive the email confirmation link in your primary inbox, kindly
                                    check your spam or junk emails. It will
                                    be found there.
                                </li>
                                <li>Open the email and click on the link to confirm your email address.</li>
                                <li>The link will redirect you to your Zimble home page.</li>
                                <li>Click on sign in and enter your email and password that you created your Zimble
                                    account with.
                                </li>
                                <li>You will see a green confirmation that said you have successfully signed in.</li>
                            </dd>

                            <h3>
                                <p style={{color: "red"}}></p>To Access Aditional Functionality:
                            </h3>
                            <dd>
                                <li>
                                    Click on “Sign In” located at the top right of your browser
                                </li>
                            </dd>
                            <p>
                                <strong>
                                    If you already created an account, enter your Email, and password and click Sign in
                                    to continue.
                                </strong>
                            </p>
                            <p>
                                Once you signed in, you will see on the top right of your browser
                                “<b>Add a Question</b>”, and “<b>Add a Video</b>” feature which gives you access to Add
                                a Question and
                                Upload a Video.
                            </p>

                            <h3>
                                <p style={{color: "red"}}>How to Add a Question:</p>
                            </h3>
                            <dd>
                                <li>Click “<b>Add a question</b>” at the top of the navbar that will take you to a box.
                                </li>
                                <li>Step one of the Question Modal asked you to add the question you have.</li>
                                <li>Click next for step 2.</li>
                                <li>Step 2 you have to choose a category where your question belongs.</li>
                                <li><b>Note***</b> If you cannot see a category to your question put it in “<b>Other</b>”
                                </li>
                                <li>Step 3 you click on <b>Submit</b>.</li>
                                <li>Wait until you see a <b>Green Colored Confirmation</b> to show a confirmation that
                                    your question was submitted successfully.
                                </li>
                                <li>Click <b>Ok</b> to complete.</li>
                            </dd>

                            <p>
                                <b>***Note:</b>
                                It is very important you choose a category for your question because your
                                question will be placed in that category you
                                choose. The reason for this is because if anyone that is an
                                expert in that category will just go there and answer your
                                question.

                            </p>

                            <h3>
                                <p style={{color: "red"}}>How to Upload a Video:</p>
                            </h3>
                            <dd>
                                <li>Click on “<b>Add a question</b>” which will take you to a box.</li>
                                <li>Step 1 you need to describe what the video is about.</li>
                                <li>Step 2 it is very important you choose which <b>Category</b> your video belongs.
                                </li>
                                <li><b>Note***</b> If you cannot see a category to your video put it in “<b>Other</b>”
                                </li>
                                <li>Step 3 you upload the video.</li>
                                <li>Step 4 you press <b>Submit.</b></li>
                                <li>Once you submit, you will see “<b>Uploading video</b>”</li>
                                <li>It takes a few minutes for the video to upload depending on the file and your
                                    internet service or provider.
                                </li>
                                <li>Wait until you see the <b>Green Confirmation</b> that your video was successfully
                                    uploaded.
                                </li>
                                <li>It is very important you click “<b>Ok</b>” after you see the confirmation to
                                    complete the process.
                                </li>
                                import Header from '../Header';

                            </dd>

                            <p>
                                <b>***Note:</b>
                                If you are in the process of adding a question or video,
                                you are unable to view anything else until you complete the
                                process.
                            </p>

                            <h3>
                                <p style={{color: "red"}}>How to Comment on a Video or Answer a Question:</p>
                            </h3>
                            <dd>
                                <li>
                                    With every Question posted or Video upload,
                                    there is an icon with three dots in the middle.

                                </li>
                                <li>
                                    Click on it, and it will take you to a box where you can
                                    give your answer or thoughts.
                                </li>
                                <li>
                                    Click <b>Post</b> to give your Answer or Comment.
                                </li>

                            </dd>
                            <h3>
                                <p style={{color: "red"}}>On the top left of your browser, you will see “Questions” and
                                    “Videos”</p>
                            </h3>

                            <dd>
                                <li>
                                    This Distinguised Contents between Questions and Videos.
                                </li>
                                <li>
                                    The “<b>Questions</b>” and “<b>Videos</b>” consists of
                                    categories on the left side of your browser with different Subjects and Classes.
                                </li>
                                <li>
                                    View the categories to explore questions or watch different categories of videos.
                                </li>
                            </dd>

                            <h3>
                                <p style={{color: "red"}}>Download a Video:</p>
                            </h3>
                            <dd>
                                <li>
                                    Click on the bottom right of the video here you see the three vertical dots.

                                </li>
                                <li>
                                    Click Download.
                                </li>
                                <strong>This gives you access to view videos without an internet connection.</strong>
                            </dd>

                            <h3>
                                <p style={{color: "red"}}>Scroll while watching a video:</p>
                            </h3>
                            <dd>
                                <li>
                                    Click on the bottom right of the video where you see the three vertical dots.
                                </li>
                                <li>
                                    Click “Picture in Picture”
                                </li>
                                <strong>This gives you access to watch videos
                                    while looking at questions or doing something else outside Zimble</strong>
                            </dd>

                            <h3>
                                <p style={{color: "red"}}>Edit or Delete a Question or Video:</p>
                            </h3>

                            <dd>
                                <li>
                                    Hover or click over the top right of your browser.
                                </li>
                                <strong>You will see:</strong>
                                <li>Your Name.</li>
                                <li> Your Content, which means Questions.</li>
                                <li>Your videos.</li>

                                <strong>Click on “Your content” or "Your Videos"</strong>
                                <li>
                                    It will take you to a page with all your Questions or Videos.
                                </li>
                                <li>Each Question or Video has a sign that looks like a pen and a straight line
                                    underneath it
                                </li>
                                <li>You can click on that and make an edit to your post or video.</li>
                                <li>Click <b>Edit</b> and you will see the changes.</li>
                                <strong>To Delete a Post or Video</strong>
                                <li>
                                    Follow the same step on how to edit a post and when you see the “X” means you can
                                    delete automatically.
                                </li>
                            </dd>
                            <h3>

                                <p style={{color: "red"}}>How to Log Out:</p>
                            </h3>
                            <dd>
                                <li>
                                    Hover or click over the top right of your browser.

                                </li>
                                <li>
                                    You will see <b>Log Out.</b>
                                </li>
                                <li>
                                    Click on it to successfully <b>Log Out</b> of Zimble.
                                </li>
                            </dd>


                            {/* <h3>
                Thank you for using Zimble. If you have any questions or what
                 to give us feedback, use this 
                 link to <a href="https://forms.gle/ppSotcR73RmQPHEX7"> 
                    Contact Us</a> or emaill us at "support@thezimble.com". 
                    We would be happy to help.</a>
            </h3> */}

                        </article>

                    </div>

                </section>


            </React.Fragment>

        )
    }

}

export default UseZimble